module.exports = __webpack_public_path__ + "static/media/csu.ca1d623d.png";